<template>
  <div
    id="data-list-thumb-view"
    class="data-list-container vs-con-loading__container"
  >
    <div>
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <div
            class="
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-between
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
            @click="createItem"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>
        <div class="con-input-search vs-table--search">
          <input
            type="text"
            class="input-search vs-table--search-input"
            v-model="searchQuery"
            v-debounce:300ms="search"
            style="font-size: 1rem"
          />
          <i class="vs-icon notranslate icon-scale material-icons null"
            >search</i
          >
        </div>
      </div>

      <div class="vs-component vs-con-table stripe vs-table-primary mt-5">
        <div class="con-tablex vs-table--content">
          <div class="vs-con-tbody vs-table--tbody">
            <table class="vs-table vs-table--tbody-table">
              <thead class="vs-table--thead">
                <tr>
                  <th class="col-0 col">Name</th>
                  <th class="col-0 col">Owner</th>
                  <th class="col-0 col">Renewal</th>
                  <th class="col-0 col">Status</th>
                  <th class="col-0 col"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="tr in data.hits"
                  :key="tr.id"
                  class="tr-values vs-table--tr tr-table-state-null selected"
                >
                  <td class="td vs-table--td">
                    <div class="flex">
                      <div class="mr-3">
                        <vs-avatar :src="tr.logoUrl" />
                      </div>
                      <div>
                        <p class="product-name font-medium">
                          {{ tr.name }} #{{ tr.contractNumber }}
                        </p>
                        <p class="product-name small">
                          {{ tr.category.nameId }}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td class="td vs-table--td">
                    <div v-if="tr.author">
                      <p>{{ tr.author.name }}</p>
                      <a
                        v-if="tr.author.email"
                        :href="`mailto:${tr.author.email}`"
                        :title="tr.author.email"
                        >{{ tr.author.email }}</a
                      >
                      <a
                        v-if="tr.author.phone"
                        :href="`tel:${tr.author.phone}`"
                        :title="tr.author.phone"
                        >{{ tr.author.phone }}</a
                      >
                    </div>
                  </td>
                  <td class="td vs-table--td">
                    <p>
                      {{ formatDate(tr.dateRenewal) }} ({{
                        formatIDR(tr.priceRenewal)
                      }})
                    </p>
                  </td>
                  <td class="td vs-table--td">
                    <status-chip :data="tr.status" />
                  </td>
                  <vs-td class="td vs-table--td">
                    <div class="action-inline-group">
                      <vs-button
                        color="dark"
                        type="flat"
                        icon="menu"
                        title="Edit content"
                        @click="$router.push(`/data/business/${tr.objectID}`)"
                      />
                      <vs-button
                        color="dark"
                        type="flat"
                        icon="edit"
                        title="Edit listing information"
                        @click="editItem(tr.objectID, tr)"
                      />
                      <vs-button
                        color="danger"
                        type="flat"
                        icon="delete"
                        title="Delete listing"
                        @click="confirmDelete(tr.objectID)"
                      />
                    </div>
                  </vs-td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <list-form
      :item-id="formData.id"
      :form-title="formData.title"
      :form-data="formData.data"
      :is-sidebar-active="formData.show"
      @closeSidebar="formData.show = false"
      @createdListing="createdListing"
    />
  </div>
</template>


<script>
import ListForm from "./ListForm";

export default {
  components: { ListForm },
  data() {
    return {
      isSearching: false,
      searchQuery: "",
      data: {
        hits: [],
        query: "",
      },
      itemsPerPage: 10,
      isMounted: false,
      formData: {
        show: false,
        title: "",
        id: null,
        data: {},
      },
      idForDeletion: null,
      statusColor: {
        Active: "success",
        Pending: "warning",
        Hidden: "dark",
        "Expiring Soon": "danger",
      },
    };
  },
  methods: {
    editItem(id, data) {
      this.formData.show = true;
      this.formData.data = data;
      this.formData.id = id;
      this.formData.title = "Edit listing";
    },
    createItem() {
      this.formData.show = true;
      this.formData.data = {
        status: "pending",
      };
      this.formData.id = null;
      this.formData.title = "Register listing";
    },
    confirmDelete(id) {
      this.idForDeletion = id;
      this.showConfirmDeletion(this.deleteItem);
    },
    deleteItem() {
      this.$store
        .dispatch("businessDoc/deleteData", this.idForDeletion)
        .then((payload) => {
          var findIndex = this.data.hits.findIndex(
            (item) => item.objectID === payload
          );
          if (findIndex > -1) {
            this.data.hits.splice(findIndex, 1);
          }
        });
    },
    search() {
      this.isSearching = true;
      this.$store
        .dispatch("businessDoc/search", this.searchQuery)
        .then((res) => (this.data = res))
        .catch((e) => console.log(e))
        .then(() => (this.isSearching = false));
    },
    createdListing(data) {
      this.data.hits.push(data);
    },
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  mounted() {
    this.isMounted = true;
    this.search();
  },
};
</script>


<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
